<template>
    <div>
        <el-form ref="ruleForm"  :label-width="!$store.getters.isPC ? '0px' : '250px'" :label-position="!$store.getters.isPC ? 'top' : 'left'" :rules="rules"  :model="formLabelAlign">
            <el-form-item label="賬戶電郵 Account Email">
                <el-input disabled v-model="formLabelAlign.email"></el-input>
            </el-form-item>
            <el-form-item label="現使用密碼 Current Password">
                <el-input disabled v-model="formLabelAlign.currentPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密碼 New Password" prop="newPassword">
                <el-input v-model="formLabelAlign.newPassword" show-password></el-input>
            </el-form-item>
            <el-form-item label="確認密碼 Confirm Password" prop="confirmPassword">
                <el-input v-model="formLabelAlign.confirmPassword" show-password></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        props:{
            isDetail: {
                type: Boolean,
                default: false,
            },
            formLabelAlign: {
                type: Object,
                default: function(){},
            },
        },
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("The password cannot be empty.密碼不能為空。"));
                } else {
                    if (this.formLabelAlign.confirmPassword !== "") {
                    this.$refs.ruleForm.validateField("confirmPassword");
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("The password cannot be empty.密碼不能為空。"));
                } else if (value !== this.formLabelAlign.newPassword) {
                    callback(new Error("The password and its confirm are not the same.密碼和確認密碼不一致。"));
                } else {
                    callback();
                }
            };
            return {
               
                rules:{
                    newPassword: [
                            { validator: validatePass, trigger: "blur" },
                    ],
                    confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
                    }
            }
        },
    }
</script>

<style lang="scss" scoped>
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .el-form-item{
        text-align: left;
    }
}
</style>